import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { STORAGE_KEYS } from '../enums/storage-keys.enum';

@Injectable({
  providedIn: 'root'
})
export class TimeHandlerService {
  currentTime: number = 0;
  constructor(
    private storage: StorageService
  ) { }

  private _timeDelayToResendVerificationCode = 0;

  public get timeDelayToResendVerificationCode(): number {
    const cookieExists: boolean = this.storage.checkCookie(
      STORAGE_KEYS.WAIT_TO_RESEND_CODE
    );
    if (!cookieExists) {
      this._timeDelayToResendVerificationCode = 0;
    } else {
      try {
        const cookieData = JSON.parse(
          this.storage.getCookie(STORAGE_KEYS.WAIT_TO_RESEND_CODE)
        );
        const expiresAt = cookieData.expiresAt;

        if (
          expiresAt &&
          (typeof expiresAt.time === 'number' || expiresAt.date instanceof Date)
        ) {
          const currentTime = new Date().getTime();
          const expirationTime =
            expiresAt.time instanceof Date
              ? expiresAt.time.getTime()
              : expiresAt.time;
          this._timeDelayToResendVerificationCode =
            expirationTime - currentTime;
        } else {
            this._timeDelayToResendVerificationCode = 0;
        }
        // const delay =  JSON.parse(this.storage.getCookie(StorageKeys.waitToResendCode)).expiresAt['time'] - (new Date().getTime());
        // this._timeDelayToResendVerificationCode = delay;
        
      } catch (error) {
        console.error('Failed to parse the cookie:', error);
        this._timeDelayToResendVerificationCode = 0;
      }
    }
    return this._timeDelayToResendVerificationCode;
  }
  public set timeDelayToResendVerificationCode(value) {
    this._timeDelayToResendVerificationCode = value;
  }
}
